<template>
  <div>
    <div v-if="bootLoading" class="page-loading">
      <van-loading type="spinner" color="#1989fa" size="36px" />
    </div>

    <!-- 通用模板 -->
    <div v-else-if="showHome && shortUrlPageTemplate === 0" id="loginbox">
      <img src="@/assets/img/Special/specialPost1.png" />

      <van-form class="lform" ref="form" @submit="submit">
        <van-field
          class="lform-input phone"
          placeholder="请输入手机号"
          v-model="form.phone"
          name="phone"
          :rules="[
            {
              required: true,
              validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
              message: '请填写正确的手机号'
            }
          ]"
        />
        <van-field
          class="lform-input yzm"
          placeholder="请输入验证码"
          v-model="form.code"
          :rules="[
            {
              required: true,
              message: '请输入验证码'
            }
          ]"
        >
          <template #button>
            <div class="cdown" v-if="!time" @click="sendCode">获取验证码</div>
            <van-count-down
              class="cdown"
              v-else
              :time="time"
              @finish="time = 0"
            />
          </template>
        </van-field>
        <van-button
          class="submit"
          :loading="subLoading"
          native-type="submit"
          loading-text="兑换中..."
        >
          去兑换
        </van-button>
      </van-form>
      <div class="lform explain">
        <div class="tips">兑换说明</div>
        <div>
          1、首次获取券码需要输入手机号码验证码进行校验，第二次进入则无需再验证；<br />
          2、请在有效期内使用，过期将无法使用，不退换不补偿；<br />
          3、若兑换后显示库存不足，请重新兑换或联系客服，客服电 话：
          <a href="tel:4006627299">4006627299</a>；
        </div>
      </div>
    </div>

    <!-- 互金模板 -->
    <div
      v-else-if="showHome && [1, 2].includes(shortUrlPageTemplate)"
      class="hujin-page"
    >
      <div class="hujin-top">
        <div class="hujin-badge">
          <img
            class="hujin-badge__logo hujin-badge__logo--sync"
            src="@/assets/img/hujin/badge-sync.svg"
            alt=""
          />
        </div>
        <h1 class="hujin-title">
          <span class="hujin-title__highlight">欢迎</span>使用
        </h1>
        <p class="hujin-subtitle">Welcome to use</p>
        <div class="hujin-deco">
          <span class="hujin-deco__line hujin-deco__line--left"></span>
          <span class="hujin-deco__star">☆</span>
          <span class="hujin-deco__line hujin-deco__line--right"></span>
        </div>
      </div>

      <div class="hujin-main">
        <van-form ref="form" class="hujin-form" @submit="submit">
          <div class="hujin-field">
            <img
              class="hujin-field__icon"
              src="@/assets/img/hujin/icon-phone.svg"
              alt=""
            />
            <van-field
              v-model="form.phone"
              name="phone"
              placeholder="请输入手机号码"
              :rules="[
                {
                  required: true,
                  validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
                  message: '请填写正确的手机号'
                }
              ]"
              type="tel"
              :maxlength="11"
              :border="false"
            />
          </div>
          <div class="hujin-field hujin-field--captcha">
            <img
              class="hujin-field__icon"
              src="@/assets/img/hujin/icon-captcha.svg"
              alt=""
            />
            <van-field
              v-model="form.code"
              placeholder="请输入验证码"
              :rules="[{ required: true, message: '请输入验证码' }]"
              :border="false"
            />
            <div class="hujin-captcha-extra">
              <span class="hujin-captcha-extra__divider"></span>
              <span
                v-if="!time"
                class="hujin-captcha-extra__btn"
                @click="sendCode"
              >
                获取验证码
              </span>
              <van-count-down
                v-else
                class="hujin-captcha-extra__btn"
                :time="time"
                format="ss 秒"
                @finish="time = 0"
              />
            </div>
          </div>
          <van-button
            class="hujin-submit-btn"
            :loading="subLoading"
            loading-text="兑换中..."
            native-type="submit"
          >
            立 即 兑 换
          </van-button>
        </van-form>
      </div>

      <div class="hujin-rules">
        <div class="hujin-rules__head">
          <div class="hujin-rules__icon-wrap">
            <img src="@/assets/img/hujin/icon-rule.svg" alt="" />
          </div>
          <span class="hujin-rules__title">兑换说明</span>
        </div>
        <ul class="sync-hujin-rule-list">
          <li>
            首次获取券码需要输入手机号验证码进行校验，第二次进入则无需再验证；
          </li>
          <li>请在有效期内使用，过期将无法使用，不退换不补偿；</li>
          <li>若兑换后显示库存不足，请重新兑换或联系客服。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'vant'
import { syncVerify, sendCode, checkForSyncLink } from '@/api/SyncLink.js'

export default {
  components: {
    [Loading.name]: Loading
  },
  data() {
    return {
      time: 0,
      bootLoading: true,
      showHome: false,
      subLoading: false,
      shortUrlPageTemplate: 0,
      form: {
        redeCodeNo: undefined,
        phone: undefined,
        code: null
      }
    }
  },
  mounted() {
    const { code: redeCodeNoPwd } = this.$route.params
    this.loadData({
      redeemCodePageType: 6,
      redeCodeNoPwd,
      pageTypeMatchFlag: true
    })
  },
  methods: {
    async loadData(param) {
      this.bootLoading = true
      try {
        const { data } = await checkForSyncLink(param)
        if (data?.shortUrlPageTemplate != null) {
          this.shortUrlPageTemplate = Number(data.shortUrlPageTemplate)
        }
        this.form.redeCodeNo = data?.redeCodeNo
        if (data?.token) {
          this.$router.replace({
            name: 'SyncLinkList',
            query: data
          })
        } else {
          this.showHome = true
        }
      } catch (error) {
        this.showHome = true
        console.log(error)
      } finally {
        this.bootLoading = false
      }
    },
    async submit() {
      try {
        this.subLoading = true
        const { code, data, message } = await syncVerify({
          ...this.form,
          redeCodeType: 8, // 兑换码类型，默认传6
          redeemCodePageType: 6
        })
        this.subLoading = false
        switch (code) {
          case 0:
            this.$router.replace({
              path: '/SyncLinkList',
              query: data
            })
            break
          case 90004:
            this.$router.push({
              path: '/SyncLinkOutStock'
            })
            break
          case 3:
            this.$router.push({
              path: '/SyncLinkCrowded'
            })
            break
          default:
            this.$toast.fail({
              message: message
            })
            break
        }
      } catch (error) {
        this.subLoading = false
      }
    },
    sendCode() {
      this.$refs.form.validate('phone').then(async () => {
        const { phone, redeCodeNo } = this.form
        const { code, message } = await sendCode({
          redeCodeNo,
          redeCodeType: 8, // 兑换码类型，默认传6
          phone,
          shortUrlPageTemplate: this.shortUrlPageTemplate
        })
        if (code === 0) {
          this.time = 60000
        } else {
          this.$toast.fail({
            message: message
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/Special.less';
@import '~@/assets/style/hujinStyle.less';

.page-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.hujin-badge__logo--sync {
  width: 72px;
  height: 72px;
}

.hujin-submit-btn {
  display: block;
  width: 100%;
  height: 112px;
  line-height: 112px;
  padding: 0;
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 8px;
  color: #fff;
  background: linear-gradient(90deg, #b88729 0%, #f1c040 100%);
  border: none;
  border-radius: 24px;

  &.van-button--loading {
    opacity: 0.85;
  }
}

.sync-hujin-rule-list {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: sync-hujin-rule;

  > li {
    position: relative;
    padding-left: 52px;
    margin-bottom: 22px;
    font-size: 24px;
    line-height: 42px;
    letter-spacing: 0.5px;
    color: #4a3800;
    counter-increment: sync-hujin-rule;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: counter(sync-hujin-rule);
      position: absolute;
      left: 0;
      top: 4px;
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #9a7a10;
      background: rgba(201, 152, 10, 0.13);
      border: 2px solid rgba(201, 152, 10, 0.32);
      border-radius: 18px;
      box-sizing: border-box;
    }
  }
}
</style>
